<template>
    <div class="flex flex-col border-b border-gray-separator | md:py-1">
        <div
            class="flex flex-row flex-wrap w-full items-center transition-opacity align-baseline"
            :class="{ 'opacity-50' : disabled }">
            <div class="text-3xl p-2 "> +</div>
            <div class="text-sm font-bold w-48 p-2 "> {{ field.getFieldLabel() }}</div>
            <div class="flex flex-col md:flex-row align-baseline space-x-2 w-full p-2 text-sm items-end | md:flex-1 md:px-0">

                <div class="flex flex-col w-full md:w-1/3 mb-2 md:mb-0">
                    <label class="w-full text-xs font-bold">
                        UNIT
                    </label>
                    <select
                        class="block w-full  cursor-pointer h-8 text-sm bg-gold-orange border-2 border-g shadow-sm text-gray-700 py-1 px-2 focus:outline-none focus:bg-orange"
                        :value="sizes.unit"
                        :disabled="disabled"
                        @change="e => this.unit = e.target.value"
                    >
                        <option disabled :value="null">Choose unit</option>
                        <option value="mm">mm</option>
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                    </select>
                </div>
                <div class="flex flex-row w-full md:w-2/3">

                    <div class="flex flex-col w-1/2">
                        <label class="text-xs font-bold">WIDTH</label>
                        <input
                            class="bg-gray w-full h-8 appearance-none border-2 border-gray-light py-2 shadow-sm px-2 text-gray-700 focus:outline-none focus:border-purple-500 focus:shadow-md"
                            type="number"
                            :value="sizes.width"
                            :disabled="disabled"
                            placeholder="Set width"
                            @change="e => this.width = setValue(e.target.value)"
                        />
                    </div>
                    <div class="px-1 leading-6 mt-4 ">x</div>
                    <div class="flex flex-col w-1/2">
                        <label class="text-xs font-bold">HEIGHT</label>
                        <input
                            class="bg-gray w-full box-border h-8 appearance-none border-2 border-gray-light py-2 shadow-sm px-2 text-gray-700 focus:outline-none focus:shadow-md focus:border-purple-500"
                            type="number"
                            :value="sizes.height"
                            :disabled="disabled"
                            placeholder="Set height"
                            @change="e => this.height = setValue(e.target.value)"
                        />
                    </div>
                </div>
            </div>
            <div class="flex align-center w-10 text-xs px-2"></div>
        </div>
        <slide-up-down :active="showDescription" :duration="1000">
            <FiledOptionsDescriptions :field="field"/>
        </slide-up-down>
    </div>

</template>

<script lang="js">
import SlideUpDown from 'vue-slide-up-down'
import ProductFieldOption from "../../../_models/ProductFieldOption";
import FiledOptionsDescriptions from "../FiledOptionsDescriptions";

export default {
    name: "MirrorSize",
    components: { SlideUpDown, FiledOptionsDescriptions },
    props: {
        field: {},
        sizes: {},
        selected: {
            default: null
        },
        disabled: {
            default: true
        },
        fieldUpdated: {
            type: Function,
            default: () => {}
        },
        isCircleSelected:{
            type: Boolean
        }
    },
    mounted(){
        this.height = this.sizes.height;
        this.width = this.sizes.width;
    },
    data() {
        return {
            height: this.sizes.height,
            width: this.sizes.width,
            unit: this.sizes.unit
        }
    },
    watch: {
        height() { this.updateHeight() },
        width() { this.updateWidth() },
        unit() { this.changed() },
    },
    computed:{
        showDescription(){
            return !this.disabled && !this.field.selectedOption
        },
    },
    methods: {
        setValue(value) {
            return value === '' ? '' : parseFloat(value)
        },
        allFieldsSelected() {
            return this.height && this.width && this.unit
        },
        updateWidth(){
            if(this.isCircleSelected){
                this.height = this.width;
            }
            this.changed();
        },
        updateHeight(){
            if(this.isCircleSelected){
                this.width = this.height;
            }
            this.changed();
        },
        changed() {
            this.field.selectedOption = null;
            this.field.mapToForm = this.mapToForm();

            if (this.allFieldsSelected()) {
                this.field.selectedOption = ProductFieldOption.fromPlain({
                    name: 'Mirror Size',
                    price: 0
                });
            }

            this.fieldUpdated();
        },
        mapToForm() {
            return [
                {
                    id: 'height',
                    name: 'Height',
                    label: 'Height',
                    selected: {
                        name: this.height
                    }
                },
                {
                    id: 'width',
                    name: 'Width',
                    label: 'Width',
                    selected: {
                        name: this.width
                    }
                },
                {
                    id: 'unit',
                    name: 'Size Type',
                    label: 'Size Type',
                    selected: {
                        name: this.unit
                    }
                }
            ]

        }
    },
}
</script>